<template>
  <div class="page page-home">
    <Home></Home>
  </div>
</template>

<script>
import Home from '../containers/Home.vue';

export default {
  name: 'HomePage',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
    Home,
  }
}
</script>

<style lang="scss"></style>
